<template>
  <div class="wrap talk re-style">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content" :style="'gap:30px;'">
        <template v-if="statCd === '' || statCd === 'P' || statCd === 'Y'">

        </template>
        <template v-else>
          <section class="form-section">
            <h2 class="page-header__title">
              신청 취소
            </h2>
          </section>
          <article  class="certification">
            <section class="txt return"  v-if="statCd === 'X' || statCd === 'D'">
              <p class="return-txt">
                <span class="return-txt-span">{{msg.headerMsg}}</span>
                <br />
                {{msg.detailMsg}}
              </p>
            </section>
            <section class="txt aconfirm" v-else-if="statCd === 'R'">
              <p class="aconfirm-txt">
                <span class="aconfirm-txt-span">신청이 취소되었어요</span>
                <br />
                언제든 다시 신청하실 수 있어요!
              </p>
            </section>
          </article>
          <div id="regBtnDiv" class="ui-buttons">
            <ul class="ui-buttons__list">
              <li class="ui-buttons__item">
                <button
                  type="button"
                  class="ui-button ui-basic-button"
                  @click="handleCloseBtn()"
                >
                  확인
                </button>
              </li>
            </ul>
          </div>
          <div class="cs-center row row_ac row_jsc">
            <span class="qa">고객센터 문의 </span>
            <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
          </div>
        </template>
      </main>
    </div>
  </div>
</template>


<script>
import Vue from 'vue' 
import AppConfig from '@/config'
import { DxCheckBox } from "devextreme-vue/check-box";
import Header from '../sale/components/Header.vue'

export default {
  name: 'VisitMintit',
  components: {
    DxCheckBox
    ,Header
  },
  data: () => ({
    ordNum: null,
    isDone:false, // 픽업 신청시
    statCd:'',
    msg:{
      headerMsg:'',
      detailMsg:''
    }
  }),
  computed: {
  },
  watch:{
  },
  async mounted () {
    this.ordNum  = decodeURIComponent(this.$route.query.ordNum).trim();
    await this.checkOrder()
  },
  methods: {
    async submit (params) {

      const {data} = await this.$http.post('/api/purchase/pcs/mgmt/public/mintit/home/immediately/cncl',params);
      this.statCd = 'R'
    },
    async checkOrder () {
      if (!this.ordNum) {
        this.$Alert.alert('접수번호 값이 존재하지 않습니다.');
        return;
      }
      // Y인지 N인지 가져오고
      // 신청가능하면 바로 Alert창 노출.
      // alert창 메세지는 그냥 시간대 가져와서 찍자.
      const params = {
        ordNum: this.ordNum
      }
 
      const {data} = await this.$http.post('/api/purchase/pcs/mgmt/public/mintit/home/immediately/cncl/chk',params);
      // Y,P 이면 신청가능, D면 취소 완료, X면 취소불가
      this.statCd = data.result.stat_cd
      let add_c = ''
      if(this.statCd === 'P'){
        add_c = '익일 '
      } else if (this.statCd === 'X' ){
        this.msg.headerMsg='지금은 취소가 어려워요'
        this.msg.detailMsg='신청 취소가 가능한 시간이 지났어요 '
        return;
      } else if (this.statCd === 'D'){
        this.msg.headerMsg='이미 취소가 완료 되었어요'
        this.msg.detailMsg='언제든 다시 신청할 수 있어요!'
        return;
      }



      let msg = `
        <h3>정말 신청을 취소할까요?</h3>
        <div style="font-size: 14px; font-weight: 400; line-height:18px;">
          <br>중고폰 가격은 오늘이 제일 비싸요!
        </div>
        <div style="font-size: 12px; font-weight: 400;">
          ※ 신청 취소는 ${add_c}오후 9시까지 가능해요
        </div>
      `

      const isTrue = await this.$Alert.customSelect(msg,true,'취소할게요','돌아가기')
      if (!isTrue) {
        this.handleCloseBtn()
      } else {
        this.submit(params)
      }
    },

    closeWindow () {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('kakaotalk') > -1) {
        if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    },


    handleCloseBtn(){
      this.closeWindow()
      return
    }
  }
}
</script>

<style scoped>
.return-txt-span{
  font-weight: bold;
  font-size:18px;
  margin-bottom: 20px;
}

.aconfirm-txt-span{
  font-weight: bold;
  font-size:18px;
  margin-bottom: 20px;
}

.donate-container2{
  font-family:"SUIT", sans-serif;
  max-width:710px;
  width:100%;
  border-radius: 18.205px;
  background: #FFF;
  padding:106px 59px 51px;
}

.cstm-font-red {
  justify-content: center;
  align-items: center;
  display: flex;
  color:#f64c4c;
}


@media (max-width: 600px) {
  .donate-container2{
      padding:54px 29px 26px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/purchase/home/MintitHomeCncl.vue